import React from 'react'
import { get } from 'lodash'
import { CardCategory } from '../commons'
import { colors } from '../helpers'

export const Product = ({
  name,
  tva,
  price,
  stock,
  read,
  id,
  picture,
  settingFields,
  description,
  width,
  theme,
  children
}) => (
  <CardCategory
    withTheme
    width={width}
    read={read}
    tva={tva}
    stock={stock}
    name={name}
    picture={picture}
    id={id}
    description={description}
    settingFields={settingFields}
    price={price}
    theme={theme}
    children={children}
    imageHeight='30vh'
    backgroundColor={colors[get(theme, 'color.background')]}
  />
)
